import { createContext } from "react";

export interface ApiClientContextValue {
  clearCache: () => void;
  reinitialize: () => Promise<void>;
}

export const ApiClientContext = createContext<ApiClientContextValue>({
  clearCache: () => {},
  reinitialize: () => Promise.resolve(),
});
